import { EnvironmentProviders, inject, Injector, provideAppInitializer } from '@angular/core';

let globalInjector: Injector | null = null;

/**
 * Provides a global injector for accessing Angular services outside the standard DI context.
 * Useful for scenarios where dependency injection is not directly available, such as static functions or error handlers.
 * The global injector is set during app initialization and accessed via the `globalInjector` variable.
 * Always use `globalInjector` together with `runInInjectionContext()` to ensure proper Angular context.
 */
export function getGlobalInjector(): Injector | null {
  return globalInjector;
}

export function setGlobalInjector(injector: Injector) {
  globalInjector = injector;
}

export function provideGlobalInjectorInitializer(): EnvironmentProviders {
  return provideAppInitializer(() => {
    globalInjector = inject(Injector);
  });
}
